/** Вкладка единого окна УВ-12: запоминается между открытиями. */
export type HubTab = 'messages' | 'alerts' | 'tasks';
export const HUB_TAB_KEY = 'epc.hub.tab';

export function readHubTab(storage: Pick<Storage, 'getItem'> = localStorage): HubTab {
  try {
    const v = storage.getItem(HUB_TAB_KEY);
    if (v === 'messages' || v === 'alerts' || v === 'tasks') return v;
  } catch {
    /* private mode */
  }
  return 'tasks';
}

export function writeHubTab(tab: HubTab, storage: Pick<Storage, 'setItem'> = localStorage): void {
  try {
    storage.setItem(HUB_TAB_KEY, tab);
  } catch {
    /* private mode */
  }
}
